import styled from 'styled-components';
import white from 'sushiweb/tokens/color/white';
import grey from 'sushiweb/tokens/color/grey';

export const GroupDetails = styled.div`
  width: 100%;
  margin: 2.4rem 0;
  background: ${white};
  border: 0.1rem solid ${grey.z200};
  border-radius: 0.8rem;
  padding: 3.4rem 2.6rem;
  h5 {
    margin-bottom: 2.4rem;
  }
  p {
    font-size: 1.7rem;
  }
  input {
    width: 40rem;
  }
`;
